/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DashboardExerciseProgressRequest
 */
export interface DashboardExerciseProgressRequest {
    /**
     * 
     * @type {number}
     * @memberof DashboardExerciseProgressRequest
     */
    'authorID'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardExerciseProgressRequest
     */
    'exerciseUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardExerciseProgressRequest
     */
    'timeframe'?: DashboardExerciseProgressRequestTimeframeEnum;
    /**
     * 
     * @type {number}
     * @memberof DashboardExerciseProgressRequest
     */
    'year'?: number;
}

export const DashboardExerciseProgressRequestTimeframeEnum = {
    SixMonths: 'SIX_MONTHS',
    Year: 'YEAR',
    Lifetime: 'LIFETIME'
} as const;

export type DashboardExerciseProgressRequestTimeframeEnum = typeof DashboardExerciseProgressRequestTimeframeEnum[keyof typeof DashboardExerciseProgressRequestTimeframeEnum];


